// Messages for operator/QuoteRequestDetail (auto-merged by lib/i18n.ts).
export const en = {
  'operator.quote_request.head': 'Quote request — {title}',
  'operator.quote_request.back': 'Quote requests',
  'operator.quote_request.untitled': 'Quote request',
  'operator.quote_request.converted': 'Converted to quote {ref} — open it',
  'operator.quote_request.dismissed': 'This request was dismissed.',
  'operator.quote_request.section.shipment': 'Shipment',
  'operator.quote_request.section.cargo': 'Cargo',
  'operator.quote_request.section.details': 'Notes',
  'operator.quote_request.section.contact': 'Contact',
  'operator.quote_request.field.mode': 'Mode',
  'operator.quote_request.field.load_type': 'Load type',
  'operator.quote_request.field.incoterm': 'Incoterm',
  'operator.quote_request.field.origin': 'Origin',
  'operator.quote_request.field.destination': 'Destination',
  'operator.quote_request.field.cargo_ready': 'Cargo ready',
  'operator.quote_request.field.commodity': 'Commodity',
  'operator.quote_request.field.weight': 'Weight',
  'operator.quote_request.field.volume': 'Volume',
  'operator.quote_request.field.reference': 'Reference',
  'operator.quote_request.field.name': 'Name',
  'operator.quote_request.field.company': 'Company',
  'operator.quote_request.field.email': 'Email',
  'operator.quote_request.field.phone': 'Phone',
  'operator.quote_request.field.customer': 'Customer',
  'operator.quote_request.field.requested_by': 'Requested by',
  'operator.quote_request.field.submitted': 'Submitted',
}

export const zhTW = {
  'operator.quote_request.head': '報價申請 — {title}',
  'operator.quote_request.back': '報價申請',
  'operator.quote_request.untitled': '報價申請',
  'operator.quote_request.converted': '已轉為報價 {ref} — 開啟',
  'operator.quote_request.dismissed': '此申請已被忽略。',
  'operator.quote_request.section.shipment': '貨件',
  'operator.quote_request.section.cargo': '貨物',
  'operator.quote_request.section.details': '備註',
  'operator.quote_request.section.contact': '聯絡資訊',
  'operator.quote_request.field.mode': '運輸方式',
  'operator.quote_request.field.load_type': '裝載類型',
  'operator.quote_request.field.incoterm': '貿易條件',
  'operator.quote_request.field.origin': '起運地',
  'operator.quote_request.field.destination': '目的地',
  'operator.quote_request.field.cargo_ready': '備貨日期',
  'operator.quote_request.field.commodity': '品名',
  'operator.quote_request.field.weight': '重量',
  'operator.quote_request.field.volume': '體積',
  'operator.quote_request.field.reference': '參考編號',
  'operator.quote_request.field.name': '姓名',
  'operator.quote_request.field.company': '公司',
  'operator.quote_request.field.email': '電子郵件',
  'operator.quote_request.field.phone': '電話',
  'operator.quote_request.field.customer': '客戶',
  'operator.quote_request.field.requested_by': '申請人',
  'operator.quote_request.field.submitted': '提交時間',
}
